import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';

export class AccountDetailsDataProvider extends BaseWebComponentDataProvider {
  async resyncLdapUsers(): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'LdapUsers',
      method: 'resync',
      payload: {},
    });
  }

  async finishedResyncLdapUsers(): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'LdapUsers',
      method: 'finishedResync',
      payload: {},
    });
  }

  async getUsersTimezone(): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Users',
      method: 'getTimezone',
      payload: {},
    });
  }
}
